import React from "react";
import { calcScore } from "../score";
import randomElement from './randomElement';
import positive from './positive';
import negative from './negative';

let showRight = false;
let globCommShow = "wrong";

function message(minigame, mode){
    let {form, isCompleted, minigameType, comm} = minigame;
    let result = {};
    let globComm = comm ? <p>{comm}</p> : false;
    if(noMsgModes.indexOf(minigameType) !== -1){
        return {};
    }
    let head;
    let tail = [];
    let succ = "";

    result.onFinish = (playerAns) => {
        let comm = false;
        let correctAns = form.correct;
        /* let right = "Вы выбрали правильный ответ "; */
        let wrong = "Вы выбрали неправильный ответ ";
        let nf = "Вы не выбрали правильный ответ ";
        let score = calcScore(minigame, playerAns);

        if(isCompleted(form, playerAns)){
            head = <p align='center'>{randomElement(positive)}</p>;
            succ = <p>{scoreMsg(score)}</p>;
            if(globCommShow !== "right" && globCommShow !== "all"){
                globComm = false;
            }
        }
        else {
            head = <p align='center'>{randomElement(negative)}</p>;
            if(globCommShow !== "wrong" && globCommShow !== "all"){
                globComm = false;
            }
        }

        if(mode === 1){
           return <div>{head}{succ}</div>; 
        }

        let isEmptyComm = form.comms.some(elem => elem !== null);
        
        if(!Array.isArray(playerAns)){
            playerAns = [playerAns];
            correctAns = [correctAns];
        }
/*         let rightAns = playerAns.filter(elem => correctAns.indexOf(elem) !== -1); */
        let missedAns = correctAns.filter(elem => playerAns.indexOf(elem) === -1);
        let wrongAns = playerAns.filter(elem => correctAns.indexOf(elem) === -1);

        
        if(form.type === "ManyAnsQuestion"){
            comm = <p align='center'>Выбрано вариантов: {playerAns.length} (правильно: 
                <span className="good"> {correctAns.length - missedAns.length}</span>/{correctAns.length}
                {wrongAns.length !== 0 ? <>, неправильно: <span className="bad">{wrongAns.length}</span></> : false}).</p>;
        }

        /* for(let i = 0; i < rightAns.length; i++){
            tail.push(<li className="commentary" key={i}>{right + "«" + form.options[rightAns[i]] + "»."}</li>);
            if(form.comms[rightAns[i]] !== null) tail.push(<p className="commentary" key={i}>{form.comms[rightAns[i]]}</p>);
        } */
        for(let i = 0; i < wrongAns.length; i++) {
            tail.push(<li className="commentary" key={"wrong" + i}>{wrong + "«" + form.options[wrongAns[i]] + "»."}</li>);
            if(form.comms[wrongAns[i]] !== null) tail.push(<p className="commentary" key={"wrong" + i + 100}>{form.comms[wrongAns[i]]}</p>);
        }
        if(showRight){
            for(let i = 0; i < missedAns.length; i++){
                tail.push(<li className="commentary" key={"missed" + i}>{nf + "«" + form.options[missedAns[i]] + "»."}</li>);
                if(form.comms[missedAns[i]] !== null) tail.push(<p className="commentary" key={"missed" + i + 100}>{form.comms[missedAns[i]]}</p>);
            }
        }
        
        if(tail.length !== 0){
            tail = <ol>{tail}</ol>;
        }
        else{
            tail = false;
        }
        if(isEmptyComm) {
            return <div>{head}{comm}{tail}{succ}</div>; 
        }

        return <div>{head}{comm}{tail}{globComm}{succ}</div>; 
        
    }
    return result;

}

const noMsgModes = ["Greeting", "Intro", "AutoFinish", "Final"];

function scoreMsg(score){
    let filter = score % 10;
    let word = "";
    switch(filter){
        case(1):
            word = "балл";
            break;
        case(2):
        case(3):
        case(4):
            word = "балла";
            break;
        default: 
            word = "баллов";
    }

    return `Ваш правильный ответ принес вам ${score} ${word}.`

}

export default message;